import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';
import { GenericDeleteDialogComponent } from '@morningstar/shared/ui-kit/generic-delete-dialog';

export function genericDeleteDialog(dialog: MatDialog, message?: string, message$?: Observable<string>) {
  return (o$: Observable<any>): Observable<any> => {
    return o$.pipe(
      map(_ => (dialog.open<GenericDeleteDialogComponent, any, boolean>(GenericDeleteDialogComponent, {
        data: {
          message,
          message$
        }
      }) as MatDialogRef<GenericDeleteDialogComponent, boolean>)
        .afterClosed()),
      mergeMap(confirmed => confirmed),
      filter(confirmed => confirmed)
    );
  }
}